module.exports = __webpack_public_path__ + "fonts/800-normal-cyrillic.70b44a9.woff2";